import React, { Component } from "react";
import { Menu, Layout } from "antd";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Link, withRouter } from "react-router-dom";
import TenderTypeConfig from "./TenderTypeConfig";
import PurchaseTypeConfig from "./PurchaseTypeConfig";
import DepartmentConfig from "./DepartmentConfig";
import CriteriaTypeConfig from "./CriteriaTypeConfig";
import TenderDocTypeConfig from "./TenderDocTypeConfig";
import MemberTypeConfig from "./MemberTypeConfig";
import VendorActivity from "./VendorActivity";
import RequireTypeConfig from "./RequireTypeConfig";
import EmailCC from "./EmailCC";
import CodeConfig from "./CodeConfig";
import Settings from "./Settings";
import GetEmployees from "./GetEmployees";
import "./Configuration.css";
import Tender from "../Tender/Tender";
import VendorSubActivity from "./VendorSubActivity";
import MasterContractConfig from "./MasterContractConfig";

const { Content, Sider } = Layout;
const { SubMenu } = Menu;
class Configuration extends Component {
  state = {
    sMenu: 0,
    collapsed: false,
  };
  toggleCollapsed = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  onMenuChange = (e) => {
    if (e.key) {
      this.setState({
        sMenu: parseInt(e.key),
      });
    }
  };

  render() {
    let menu = (
      <Menu
        defaultSelectedKeys={["0"]}
        mode="inline"
        theme="light"
        onClick={this.onMenuChange}
      >
         {/* <Menu.Item key={0}>
          <Link className="MenuLabel">Тендерийн төрөл</Link>
        </Menu.Item> */}
        <Menu.Item key={0}>
          <span className="MenuLabel">Тендерийн төрөл</span>
        </Menu.Item>
        <Menu.Item key={1}>
          <span className="MenuLabel">Худалдан авах ажиллагаа</span>
        </Menu.Item>
        <Menu.Item key={2}>
          <span className="MenuLabel">Захиалагч</span>
        </Menu.Item>
        <Menu.Item key={3}>
          <span className="MenuLabel">Шалгуур үзүүлэлтийн төрөл</span>
        </Menu.Item>
        <Menu.Item key={4}>
          <span className="MenuLabel">Тендерийн бичиг баримтын төрөл</span>
        </Menu.Item>
        <Menu.Item key={5}>
          <span className="MenuLabel">Үнэлгээний хорооны төрөл</span>
        </Menu.Item>
         <Menu.Item key={6}>
          <span className="MenuLabel">
            Мастер гэрээний баталгааны хуудас
          </span>
        </Menu.Item>
        {/* <Menu.Item key={6}>
          <span className="MenuLabel">
            Нийлүүлэгчийн үйл ажиллагааны чиглэл
          </span>
        </Menu.Item>
        <Menu.Item key={12}>
          <span className="MenuLabel">
            Үйл ажиллагааны дэд чиглэл
          </span>
        </Menu.Item> */}
        <Menu.Item key={7}>
          <span className="MenuLabel">И-мэйл илгээх ажилчид</span>
        </Menu.Item>
        <Menu.Item key={8}>
          <span className="MenuLabel">Дугаарлалт</span>
        </Menu.Item>
        <Menu.Item key={9}>
          <span className="MenuLabel">Бүрдүүлэх материалын төрөл</span>
        </Menu.Item>
        <Menu.Item key={10}>
          <span className="MenuLabel">Эрхийн тохиргоо</span>
        </Menu.Item>
        <Menu.Item key={11}>
          <span className="MenuLabel">Ажилтан татах</span>
        </Menu.Item>
      </Menu>
    );
    return (
      <div id="config">
        <Switch>
          <Layout>
            <Sider style={{ height: "100vh", backgroundColor: "#fff" }}>
              {menu}
            </Sider>
            <Content>
              {this.state.sMenu === 0 ? (
                <TenderTypeConfig />
              ) : this.state.sMenu === 1 ? (
                <PurchaseTypeConfig />
              ) : this.state.sMenu === 2 ? (
                <DepartmentConfig />
              ) : this.state.sMenu === 3 ? (
                <CriteriaTypeConfig />
              ) : this.state.sMenu === 4 ? (
                <TenderDocTypeConfig />
              ) : this.state.sMenu === 5 ? (
                <MemberTypeConfig />
              ) : this.state.sMenu === 6 ? (
                <MasterContractConfig />
              ) : this.state.sMenu === 7 ? (
                  <EmailCC />  
              ) : this.state.sMenu === 12 ? (
                <VendorSubActivity />
              ) : this.state.sMenu === 8 ? (
                <CodeConfig />
              ) : this.state.sMenu === 9 ?
                <RequireTypeConfig />
                : this.state.sMenu === 10 ?
                  <Settings />
                  : this.state.sMenu === 11 ?
                    <GetEmployees />
                    : null}
            </Content>
          </Layout>
        </Switch>
      </div>
    );
  }
}

export default withRouter(Configuration);
